import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';
import type { DefaultApiParams } from '@/std/pagination/types';
import { fetchApi } from '@/std/api/fetchApi';
import { registrosSchema } from '@/std/schema';
import { ProdutoCategoriaSchema } from '../types/ProdutoCategoria';

export type ProdutoCategoriaConsultarParams = Partial<
    DefaultApiParams & {
        descricao: string;
    }
>;

const schema = registrosSchema(ProdutoCategoriaSchema);

function apiProdutoCategoriaConsultar(params: ProdutoCategoriaConsultarParams) {
    return fetchApi({
        endpoint: 'ProdutoCategoria/Consultar',
        method: 'get',
        params,
        schema,
    });
}

export const API_PRODUTO_CATEGORIA_CONSULTAR = 'apiProdutoCategoriaConsultar';

export function apiProdutoCategoriaConsultarQueryOptions(params: ProdutoCategoriaConsultarParams) {
    return queryOptions({
        queryFn: () => apiProdutoCategoriaConsultar(params),
        queryKey: [API_PRODUTO_CATEGORIA_CONSULTAR, params],
    });
}

export function apiProdutoCategoriaConsultarInfiniteQueryOptions(
    params: ProdutoCategoriaConsultarParams,
) {
    const pageSize = params.qtde_registros ?? 10;

    // biome-ignore assist/source/useSortedKeys: breaks type inference
    return infiniteQueryOptions({
        queryKey: [API_PRODUTO_CATEGORIA_CONSULTAR, params],
        queryFn: async ({ pageParam }) =>
            (
                await apiProdutoCategoriaConsultar({
                    ...params,
                    registro_inicial: pageParam,
                })
            ).registros,
        getNextPageParam: (lastPage, _, lastPageParam) => {
            if (lastPage.length < pageSize) {
                return undefined;
            }

            return lastPageParam + pageSize;
        },
        initialPageParam: 0,
    });
}
